import { CSSProperties, FC } from 'react';
import { Tag } from 'antd';
import { capitalCase } from 'change-case';
import { TbArrowUpRight, TbCircleArrowUp } from 'react-icons/tb';
import { Link } from 'react-router-dom';

import { useEntitlements } from '@/hooks/useEntitlements';

interface PlanTagProps {
    plan: 'pro' | 'enterprise' | 'plus' | 'ra' | 'premium';
    style?: CSSProperties;
}

const PlanTag: FC<PlanTagProps> = ({ plan, style }): JSX.Element => {
    const { hasMinimumPlan, planTier } = useEntitlements();
    const hideTag = plan === 'ra' ? planTier === 'enterprise' : hasMinimumPlan(plan);

    return (
        <Link data-table-of-contents-label-ignore='true' style={{ fontWeight: 500 }} to='/settings/account/plans'>
            <Tag
                color={
                    plan === 'premium'
                        ? 'gold'
                        : plan === 'plus'
                          ? 'green'
                          : plan === 'pro'
                            ? 'geekblue'
                            : plan === 'enterprise'
                              ? 'purple'
                              : 'magenta'
                }
                style={{
                    display: hideTag ? 'none' : undefined,
                    borderColor: 'transparent',
                    marginRight: 0,

                    fontWeight: 500,
                    ...style,
                }}
            >
                {/* {plan === 'pro' ? (
                    <TbBolt style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                ) : (
                    <TbBuilding style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                )} */}
                {plan !== 'ra' ? (
                    <>
                        Upgrade to {plan && capitalCase(plan)}
                        <TbCircleArrowUp style={{ verticalAlign: '-0.125rem', marginLeft: '0.25rem' }} />
                    </>
                ) : (
                    <>
                        Request Access
                        <TbArrowUpRight style={{ verticalAlign: '-0.125rem', marginLeft: '0.25rem' }} />
                    </>
                )}
            </Tag>
        </Link>
    );
};

export default PlanTag;
